module.exports = __webpack_public_path__ + "img/home-logo.3362df74.png";